import { Routes, Theme, Users } from '@just-in-types';
import { NavigateFn } from '@reach/router';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import Button from '../components/Button';
import Column from '../components/Column';
import Container from '../components/Container';
import Coupon from '../components/Coupon';
import ResetButton from '../components/ResetButton';
import Row from '../components/Row';
import Title from '../components/Title';
import ErrorBoundary from '../hoc/withErrorBoundary';
import { RouteComponentProps } from '../Site';
import {
  navigateToNext,
  NavigateToNext,
  watchCoupons,
  WatchCoupons,
} from '../store/actions';
import { IState } from '../store/reducers';
import { IStrings } from '../store/reducers/strings';

interface ICouponsDispatchProps {
  onNavigateToNext: NavigateToNext;
  onWatchCoupons: WatchCoupons;
}

interface ICouponsOwnProps extends RouteComponentProps {
  navigate: NavigateFn;
  path: Routes.RouteString;
}

interface ICouponsStateProps {
  businessId: string;
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
  userTemp: IState['userTemp'];
}
type CouponsProps = ICouponsDispatchProps &
  ICouponsOwnProps &
  ICouponsStateProps;

interface ICouponState {
  userId: string;
}

type CouponState = ICouponState;

const CouponsContainer = styled(Container)`
  grid-template-rows: 20vh 55vh 25vh;
`;
const CouponBox = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 80vw;
  min-height: 100%;
  max-height: 60vh;
  padding: 0.5rem;
  overflow-y: scroll;
  margin-bottom: auto;
  border: 2px solid black;
  border-radius: 12px;
  box-shadow: inset 1px 1px 2px 1px black;
  &::-webkit-scrollbar {
    width: 24px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0 12px 12px 0;
    background-color: #444;
    box-shadow: 0 0 0 2px black;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: ${(props: { scrollThumbBg: string }) =>
      props.scrollThumbBg};
    box-shadow: 0 0 0 2px black;
    width: 24px;
  }
`;

class Coupons extends React.Component<CouponsProps, CouponState> {
  public state: CouponState = { userId: '' };
  public watching: boolean = false;

  public componentDidMount() {
    const {
      onWatchCoupons,
      user: { userId },
    } = this.props;
    let id = userId;

    if (!userId && process.env.NODE_ENV === 'development') {
      id = 'TTeQztp4DWpkoJfs6bWr';
    }

    this.setState({ userId: id });

    if (id) {
      onWatchCoupons(id);
    }
  }

  public render() {
    const {
      businessId,
      languageStrings,
      navigate,
      theme: { colors },
      userTemp: { coupons },
    } = this.props;
    const { userId } = this.state;

    return (
      <ErrorBoundary>
        <CouponsContainer>
          <Row align="center" justify="center">
            <Title>{languageStrings.couponsHeader}</Title>
          </Row>
          <Column align="center" justify="space-around">
            <CouponBox scrollThumbBg={colors.primary}>
              {coupons.some(coupon => coupon.redemption_flag === false) ? (
                coupons.map((coupon, index) => (
                  <Coupon
                    businessId={businessId}
                    colors={colors}
                    coupon={coupon}
                    key={index}
                    userId={userId}
                    visible={!coupon.redemption_flag}
                  />
                ))
              ) : (
                <Column
                  align="center"
                  justify="space-around"
                  style={{ flex: 1, padding: '1rem' }}>
                  <Title color="black" noShadow={true}>
                    You don't have any coupons right now.
                  </Title>
                  <Title color="black" noShadow={true}>
                    Keep checking in to earn rewards!
                  </Title>
                </Column>
              )}
            </CouponBox>
          </Column>
          <Row align="center" justify="center">
            <Button bg={colors.primary} onClick={() => navigate('../thanks')}>
              {languageStrings.goBack}
            </Button>
            <ResetButton />
          </Row>
        </CouponsContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({
  router: { businessId, languageStrings },
  theme,
  user,
  userTemp,
}: IState) => ({
  businessId,
  languageStrings,
  theme,
  user,
  userTemp,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onWatchCoupons: watchCoupons,
};

export default connect<
  ICouponsStateProps,
  ICouponsDispatchProps,
  ICouponsOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(Coupons);



// WEBPACK FOOTER //
// ./src/views/Coupons.tsx